














import { computed, defineComponent } from '@vue/composition-api'
import { useActions, useGetters } from 'vuex-composition-helpers'
import ConditionForm from '@/components/organisms/questionnaire/ConditionForm.vue'
import Layout from '@/components/organisms/common/Layout.vue'
import { CreateConditionDto } from '../../../api/@types'
import { QuestionnaireGetters } from '@/store/questionnaire/getters'
import { UserGetters } from '@/store/user/getters'

export default defineComponent({
  components: { ConditionForm, Layout },
  setup(props, context) {
    const pageId = parseInt(context.root.$route.params.pageId)
    const questionId = parseInt(context.root.$route.params.questionId)
    const conditionId = parseInt(context.root.$route.params.conditionId)

    const { user } = useGetters<UserGetters>('user', ['user'])
    const { pages } = useGetters<QuestionnaireGetters>('questionnaire', [
      'pages',
      'condition',
    ])
    const { updateCondition } = useActions('questionnaire', ['updateCondition'])

    const condition = computed(() =>
      context.root.$store.getters['questionnaire/condition'](
        pageId,
        questionId,
        conditionId,
      ),
    )

    const save = async (payload: {
      body: Partial<CreateConditionDto>
      done: () => void
    }) => {
      await updateCondition({ conditionId, body: payload.body })
      context.root.$router.go(-1)
    }

    return { condition, user, pages, pageId, questionId, save }
  },
})
